var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2205 1.75373C8.12632 1.57753 7.87371 1.57753 7.77953 1.75374L1.69789 13.1323C1.60888 13.2989 1.72955 13.5002 1.91837 13.5002H14.0816C14.2705 13.5002 14.3911 13.2989 14.3021 13.1323L8.2205 1.75373ZM6.45664 1.04667C7.1159 -0.186781 8.88414 -0.186782 9.5434 1.04667L15.625 12.4253C16.2481 13.591 15.4034 15.0002 14.0816 15.0002H1.91837C0.596577 15.0002 -0.24807 13.591 0.374997 12.4253L6.45664 1.04667ZM9.00002 11.0002C9.00002 11.5525 8.55231 12.0002 8.00002 12.0002C7.44774 12.0002 7.00002 11.5525 7.00002 11.0002C7.00002 10.4479 7.44774 10.0002 8.00002 10.0002C8.55231 10.0002 9.00002 10.4479 9.00002 11.0002ZM8.75002 5.75015C8.75002 5.33594 8.41423 5.00015 8.00002 5.00015C7.58581 5.00015 7.25002 5.33594 7.25002 5.75015V8.25015C7.25002 8.66436 7.58581 9.00015 8.00002 9.00015C8.41423 9.00015 8.75002 8.66436 8.75002 8.25015V5.75015Z",
    fill: "#FF794D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWarning);
export default __webpack_public_path__ + "static/media/notification_warning.d3ba611c16dcf0791d083e8b4a9ecf95.svg";
export { ForwardRef as ReactComponent };